<template>
  <div class="modal-carousel" ref="carousel">
    <div class="gallery-cell" v-for="slide in entries" v-bind:key="slide.id">
      <inspiration :entry="slide" v-if="slide.taxonomy === 'inspirationPhoto' || slide.taxonomy === 'inspirationCaseStudy'" />
      <video-player :entry="slide" v-if="slide.taxonomy === 'Video'" />
    </div>
  </div>
</template>

<script>
import Flickity from 'flickity';
import Inspiration from './Inspiration';

const KEYCODE_LEFTARROW = 37;
const KEYCODE_RIGHTARROW = 39;

export default {
  components: {
    Inspiration,
  },
  props: ['focus', 'collection'],
  data() {
    return {
      entries: this.collection,
      pointer: null,
      flickity: null,
    }
  },
  computed: {
    startingPointerPosition() {
      for (let i=0; i < this.entries.length; i++) {
        if (this.entries[i].id == this.focus) {
            return i;
        }
      }
      return 0;
    }
  },
  mounted() {
    const eventNotTargetingCarousel = (domTarget) => {
      return domTarget !== this.$refs.carousel
                && !this.$refs.carousel.contains(domTarget);
    }

    const handleArrowKeys = (e) => {
      if (this.flickity !== null && eventNotTargetingCarousel(e.target)) {
        if (e.keyCode === KEYCODE_LEFTARROW) {
          this.flickity.previous();
        }
        if (e.keyCode === KEYCODE_RIGHTARROW) {
          this.flickity.next();
        }
      }
    };

    document.addEventListener('keydown', handleArrowKeys);

    this.$nextTick(function() {
      this.renderFlickity();
    });

    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', handleArrowKeys);
    })
  },
  methods: {
    renderFlickity() {
      if (! this.$refs.carousel) {
        return;
      }

      this.flickity = new Flickity(this.$refs.carousel, {
        imagesLoaded: true,
        percentPosition: true,
        lazyLoad: 2,
        prevNextButtons: this.entries.length > 1,
        pageDots: false,
        setGallerySize: false,
        fade: true,
        initialIndex: this.startingPointerPosition,
        arrowShape: {
          x0: 10,
          x1: 50, y1: 50,
          x2: 60, y2: 50,
          x3: 20
        }
      });

      this.flickity.select(this.active, false, true);

      this.flickity.on('change', this.updateQueryParameters);
    },
    updateQueryParameters(index) {
      let queryParams = new URLSearchParams(this.$route.query)
      queryParams.set('viewElement', this.entries[index].id)
      window.history.replaceState({}, "", decodeURIComponent(`${this.$route.path}?${queryParams}`))
    }
  },
}
</script>
